// types
import { TP_CoolingOutlet } from './types'
import { GridHeaderCell, GridCardCell } from '../../../components/Grid'

// components
import { LoadingView } from "../../../../components";
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren'
import { FormattedMessage } from 'react-intl'
import { useMemo } from 'react'
import { AutomationObjectsFlexGridView } from '../../../components/Grid/AutomationObjectsFlexGridView';
import { PlantSwitchesGrid } from '../../components/PlantSwitches';

export function OperatorPanel(props: TP_CoolingOutlet) {

    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    const sFlowPipe = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryFlowPipe");
    const sOutletPipe = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryOutletPipe");
    const flowChilds = useMemo(() => {
        const cgs = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.CoolingGenerators.SP_CoolGenerator") ?? [];
        const ccs = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.CoolingCoils.SP_CoolingCoil") ?? [];
        const fps = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_FlowPipe") ?? [];
        const pfp = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryFlowPipe") ?? [];
        return [...cgs, ...ccs, ...fps, ...pfp]
    },[childElement])
    const outletChilds = useMemo(() => {
        const c1 = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_OutletPipe") ?? [];
        const c2 = childElement?.filter((v: any) => v.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryOutletPipe") ?? [];
        return [...c1, ...c2]
    },[childElement])
    
    
    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <PlantSwitchesGrid childElements={childElement}></PlantSwitchesGrid>
            {(flowChilds && flowChilds.length > 0) &&
                <>
                    <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.Flow" defaultMessage="Flow" />}></GridHeaderCell>
                    <AutomationObjectsFlexGridView items={flowChilds}></AutomationObjectsFlexGridView>
                </>
            }
            {(outletChilds && outletChilds.length > 0) &&
                <>
                    <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.Outlet" defaultMessage="Outlet" />}></GridHeaderCell>
                    <AutomationObjectsFlexGridView items={outletChilds}></AutomationObjectsFlexGridView>
                </>
            }
           {(sFlowPipe && sFlowPipe.length > 0) &&
                <>
                     <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.FlowSecondary" defaultMessage="Flow Secondary" />}></GridHeaderCell>
                    <AutomationObjectsFlexGridView items={sFlowPipe}></AutomationObjectsFlexGridView>
                </>
            }
           {(sOutletPipe && sOutletPipe.length > 0) &&
                <>
                     <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.OutletSecondary" defaultMessage="Outlet Secondary" />}></GridHeaderCell>
                    <AutomationObjectsFlexGridView items={sOutletPipe}></AutomationObjectsFlexGridView>
                </>
            }
        </LoadingView>
    );
}

